import { render, staticRenderFns } from "./ydjytk.vue?vue&type=template&id=d24ff634&scoped=true"
import script from "./ydjytk.vue?vue&type=script&lang=js"
export * from "./ydjytk.vue?vue&type=script&lang=js"
import style0 from "./ydjytk.vue?vue&type=style&index=0&id=d24ff634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24ff634",
  null
  
)

export default component.exports